export default "//cdn.scentbird.com/assets/frontbird-site/images/bodyOil_5834cf.png";